// GENERATED from BDR_Mobile design_tokens.dart enum. token -> {label, group}. 120 tokens.
export const GROUP_ORDER = ["Backgrounds / surfaces","Gradient pairs","Text","Inputs","Controls","Status / semantic","Chrome","Drawer / nav chrome","Domain palettes","Calendar semantic colors","Office comms","Accent palette","Business metrics"];

export const TOKEN_META = {
  screenBg: { label: "Screen Bg", group: "Backgrounds / surfaces" },
  surfaceCard: { label: "Surface Card", group: "Backgrounds / surfaces" },
  surfaceModal: { label: "Surface Modal", group: "Backgrounds / surfaces" },
  surfaceScheduleModal: { label: "Surface Schedule Modal", group: "Backgrounds / surfaces" },
  surfaceSheet: { label: "Surface Sheet", group: "Backgrounds / surfaces" },
  surfaceDropdown: { label: "Surface Dropdown", group: "Backgrounds / surfaces" },
  surfaceListItem: { label: "Surface List Item", group: "Backgrounds / surfaces" },
  drawerBg: { label: "Drawer Bg", group: "Backgrounds / surfaces" },
  surfaceLight: { label: "Surface Light", group: "Backgrounds / surfaces" },
  gradAppBarStart: { label: "Grad App Bar Start", group: "Gradient pairs" },
  gradAppBarEnd: { label: "Grad App Bar End", group: "Gradient pairs" },
  gradBrandStart: { label: "Grad Brand Start", group: "Gradient pairs" },
  gradBrandEnd: { label: "Grad Brand End", group: "Gradient pairs" },
  gradBrandRevStart: { label: "Grad Brand Rev Start", group: "Gradient pairs" },
  gradBrandRevEnd: { label: "Grad Brand Rev End", group: "Gradient pairs" },
  gradBlueGreenStart: { label: "Grad Blue Green Start", group: "Gradient pairs" },
  gradBlueGreenEnd: { label: "Grad Blue Green End", group: "Gradient pairs" },
  gradGreenBlueStart: { label: "Grad Green Blue Start", group: "Gradient pairs" },
  gradGreenBlueEnd: { label: "Grad Green Blue End", group: "Gradient pairs" },
  gradSoftStart: { label: "Grad Soft Start", group: "Gradient pairs" },
  gradSoftEnd: { label: "Grad Soft End", group: "Gradient pairs" },
  gradShimmerStart: { label: "Grad Shimmer Start", group: "Gradient pairs" },
  gradShimmerEnd: { label: "Grad Shimmer End", group: "Gradient pairs" },
  gradDisabledStart: { label: "Grad Disabled Start", group: "Gradient pairs" },
  gradDisabledEnd: { label: "Grad Disabled End", group: "Gradient pairs" },
  gradRadialCardStart: { label: "Grad Radial Card Start", group: "Gradient pairs" },
  gradRadialCardEnd: { label: "Grad Radial Card End", group: "Gradient pairs" },
  textPrimary: { label: "Text Primary", group: "Text" },
  textOnLight: { label: "Text On Light", group: "Text" },
  textMuted: { label: "Text Muted", group: "Text" },
  textOnPrimary: { label: "Text On Primary", group: "Text" },
  textLink: { label: "Text Link", group: "Text" },
  inputBorder: { label: "Input Border", group: "Inputs" },
  inputBorderFocused: { label: "Input Border Focused", group: "Inputs" },
  inputBorderError: { label: "Input Border Error", group: "Inputs" },
  inputFill: { label: "Input Fill", group: "Inputs" },
  cursor: { label: "Cursor", group: "Inputs" },
  selection: { label: "Selection", group: "Inputs" },
  selectionHandle: { label: "Selection Handle", group: "Inputs" },
  labelText: { label: "Label Text", group: "Inputs" },
  hintText: { label: "Hint Text", group: "Inputs" },
  accentPrimary: { label: "Accent Primary", group: "Controls" },
  accentPrimaryAlt: { label: "Accent Primary Alt", group: "Controls" },
  switchOnTrack: { label: "Switch On Track", group: "Controls" },
  switchOnThumb: { label: "Switch On Thumb", group: "Controls" },
  switchOffTrack: { label: "Switch Off Track", group: "Controls" },
  switchOffThumb: { label: "Switch Off Thumb", group: "Controls" },
  checkboxActive: { label: "Checkbox Active", group: "Controls" },
  checkboxCheck: { label: "Checkbox Check", group: "Controls" },
  checkboxOff: { label: "Checkbox Off", group: "Controls" },
  radioActive: { label: "Radio Active", group: "Controls" },
  radioOff: { label: "Radio Off", group: "Controls" },
  sliderActive: { label: "Slider Active", group: "Controls" },
  sliderInactive: { label: "Slider Inactive", group: "Controls" },
  sliderThumb: { label: "Slider Thumb", group: "Controls" },
  progressIndicator: { label: "Progress Indicator", group: "Controls" },
  ripple: { label: "Ripple", group: "Controls" },
  error: { label: "Error", group: "Status / semantic" },
  errorMoney: { label: "Error Money", group: "Status / semantic" },
  success: { label: "Success", group: "Status / semantic" },
  warning: { label: "Warning", group: "Status / semantic" },
  warningAlt: { label: "Warning Alt", group: "Status / semantic" },
  offlineBanner: { label: "Offline Banner", group: "Status / semantic" },
  statusPending: { label: "Status Pending", group: "Status / semantic" },
  statusDraft: { label: "Status Draft", group: "Status / semantic" },
  statusInProgress: { label: "Status In Progress", group: "Status / semantic" },
  statusApproved: { label: "Status Approved", group: "Status / semantic" },
  statusScheduled: { label: "Status Scheduled", group: "Status / semantic" },
  statusVacation: { label: "Status Vacation", group: "Status / semantic" },
  statusUnscheduled: { label: "Status Unscheduled", group: "Status / semantic" },
  divider: { label: "Divider", group: "Chrome" },
  scrim: { label: "Scrim", group: "Chrome" },
  barrierScrim: { label: "Barrier Scrim", group: "Chrome" },
  shadow: { label: "Shadow", group: "Chrome" },
  shadowStrong: { label: "Shadow Strong", group: "Chrome" },
  drawerText: { label: "Drawer Text", group: "Drawer / nav chrome" },
  drawerIcon: { label: "Drawer Icon", group: "Drawer / nav chrome" },
  drawerDivider: { label: "Drawer Divider", group: "Drawer / nav chrome" },
  drawerSectionLabel: { label: "Drawer Section Label", group: "Drawer / nav chrome" },
  drawerChevron: { label: "Drawer Chevron", group: "Drawer / nav chrome" },
  drawerChevronCollapsed: { label: "Drawer Chevron Collapsed", group: "Drawer / nav chrome" },
  drawerHeaderText: { label: "Drawer Header Text", group: "Drawer / nav chrome" },
  drawerNotesBg: { label: "Drawer Notes Bg", group: "Drawer / nav chrome" },
  drawerNotesText: { label: "Drawer Notes Text", group: "Drawer / nav chrome" },
  drawerRipple: { label: "Drawer Ripple", group: "Drawer / nav chrome" },
  drawerScrim: { label: "Drawer Scrim", group: "Drawer / nav chrome" },
  jobTypeM: { label: "Job Type M", group: "Domain palettes" },
  jobTypeR: { label: "Job Type R", group: "Domain palettes" },
  jobTypeRM: { label: "Job Type R M", group: "Domain palettes" },
  jobTypeHC: { label: "Job Type H C", group: "Domain palettes" },
  eventGoBy: { label: "Event Go By", group: "Calendar semantic colors" },
  eventVacationNoUser: { label: "Event Vacation No User", group: "Calendar semantic colors" },
  priceText: { label: "Price Text", group: "Calendar semantic colors" },
  bubbleIn: { label: "Bubble In", group: "Office comms" },
  bubbleOut: { label: "Bubble Out", group: "Office comms" },
  unreadIndicator: { label: "Unread Indicator", group: "Office comms" },
  calFlamingo: { label: "Cal Flamingo", group: "Accent palette" },
  calTangerine: { label: "Cal Tangerine", group: "Accent palette" },
  calBanana: { label: "Cal Banana", group: "Accent palette" },
  calPeacock: { label: "Cal Peacock", group: "Accent palette" },
  calGrape: { label: "Cal Grape", group: "Accent palette" },
  metricAxisLabel: { label: "Metric Axis Label", group: "Business metrics" },
  metricAxisLine: { label: "Metric Axis Line", group: "Business metrics" },
  metricGridLine: { label: "Metric Grid Line", group: "Business metrics" },
  metricTileLabel: { label: "Metric Tile Label", group: "Business metrics" },
  metricTileValue: { label: "Metric Tile Value", group: "Business metrics" },
  metricRevenueBar: { label: "Metric Revenue Bar", group: "Business metrics" },
  metricProjectedBar: { label: "Metric Projected Bar", group: "Business metrics" },
  metricProjectedBadge: { label: "Metric Projected Badge", group: "Business metrics" },
  metricSeriesRefinish: { label: "Metric Series Refinish", group: "Business metrics" },
  metricSeriesMaint: { label: "Metric Series Maint", group: "Business metrics" },
  metricSeriesOther: { label: "Metric Series Other", group: "Business metrics" },
  metricCat1: { label: "Metric Cat1", group: "Business metrics" },
  metricCat2: { label: "Metric Cat2", group: "Business metrics" },
  metricCat3: { label: "Metric Cat3", group: "Business metrics" },
  metricCat4: { label: "Metric Cat4", group: "Business metrics" },
  metricCat5: { label: "Metric Cat5", group: "Business metrics" },
  metricDeltaPositive: { label: "Metric Delta Positive", group: "Business metrics" },
  metricDeltaNegative: { label: "Metric Delta Negative", group: "Business metrics" },
  metricDeltaNeutral: { label: "Metric Delta Neutral", group: "Business metrics" },
};
